import {isPlainObject} from "../type-check";

function jsonCopy(json_var) {
    return JSON.parse(JSON.stringify(json_var))
}

function jsonCompare(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}

function flattenObject(nestedObject) {
    let result = {};

    for (let key1 in nestedObject) {
        if (!nestedObject.hasOwnProperty(key1) || !isPlainObject(nestedObject[key1])) {
            continue;
        }

        for (let key2 in nestedObject[key1]) {
            if (!nestedObject[key1].hasOwnProperty(key2)) {
                continue;
            }

            if (nestedObject[key1][key2] !== null && isPlainObject(nestedObject[key1][key2])) {
                for (let key3 in nestedObject[key1][key2]) {
                    if (nestedObject[key1][key2].hasOwnProperty(key3)) {
                        const flatKey = key1 + '.' + key2 + '.' + key3;
                        result[flatKey] = nestedObject[key1][key2][key3];
                    }
                }
            } else {
                const flatKey = key1 + '.' + key2;
                result[flatKey] = nestedObject[key1][key2];
            }
        }
    }

    return result;
}

function flipObject(obj) {
    const flipped = {};

    for(let key in obj){
        if (obj.hasOwnProperty(key)) {
            flipped[obj[key]] = key;
        }
    }

    return flipped;
}

function jsonToObject(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        console.log(e);
        return null;
    }
}

export {
    jsonCopy,
    jsonCompare,
    flattenObject,
    flipObject,
    jsonToObject,
}
